import {getColorByPath, type ThemeColorPath, useFoundationTheme} from 'platform/foundation';

import {mapObjIndexed} from 'ramda';

/**
 * Resolves chart color tokens to the color values that Recharts needs for `fill` and `stroke`.
 */
export function useChartColors<TKey extends string>(colors: Record<TKey, ThemeColorPath>) {
  const theme = useFoundationTheme();
  return mapObjIndexed((color) => getColorByPath(color, theme), colors);
}
